import { baseBlogStorage } from "../config";
import axios from "axios";
import { msalInstance } from "src/lib/msal";
import zod from "zod";

const blobStorageApiInstance = axios.create({
    baseURL: baseBlogStorage,
});

blobStorageApiInstance.interceptors.request.use(
    async (config) => {
        const account = msalInstance.getAllAccounts()[0];
        if (account) {
            const { accessToken } = await msalInstance.acquireTokenSilent({
                scopes: ["User.Read"],
                account: account,
            });

            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

const authResponseSchema = zod.object({
    account: zod.string(),
    container: zod.string(),
    sas: zod.string(),
});

async function auth() {
    const sasResponse = await blobStorageApiInstance.get("/auth");

    const validatedResponse = authResponseSchema.parse(sasResponse.data);

    return validatedResponse;
}

export const blobStorageApi = {
    auth,
};
